export const createFAQObject = (apiObject) => {
  return {
    id: apiObject.id,
    title: apiObject.title,
    description: apiObject.description,
    channelId: apiObject.channelId,
    isEnabled: !apiObject.disabled,
    isLoadingToggleStatus: false,
  };
};

export const createFAQList = (apiObject) => {
  const data = apiObject.list;
  const FAQList = data.map((item) => createFAQObject(item));

  return FAQList;
};

export const sortQuestionsByOrder = (q1, q2) => {
  return q1.order - q2.order;
};

export const createQuestionObject = (apiObject) => ({
  questionId: apiObject.id,
  order: apiObject.order,
  question: apiObject.question,
  answer: apiObject.answer,
  faqId: apiObject.faqId,
  isExpanded: false,
});

export const createOnEditObject = (apiObject) => {
  const questions =
    apiObject.questions?.map((item) => ({
      ...createQuestionObject(item),
      tempId: item.id,
    })) || [];

  questions.sort(sortQuestionsByOrder);

  return {
    channelId: apiObject.channelId,
    faqTitle: apiObject.title,
    faqId: apiObject.id,
    faqDescription: apiObject.description,
    isEnabled: !apiObject.disabled,
    questions,
  };
};

export const createAPIObjectForUpdateFAQ = (onEditFAQ) => ({
  faqId: onEditFAQ.faqId,
  title: onEditFAQ.faqTitle,
  description: onEditFAQ.faqDescription,
  disabled: !onEditFAQ.isEnabled,
});

export const createAPIObjectForCreateFAQ = (onEditFAQ) => ({
  title: onEditFAQ.faqTitle,
  description: onEditFAQ.faqDescription,
  channelId: onEditFAQ.channelId,
  disabled: false,
});

export const getQuestionIds = (questions) => {
  return questions.map((q) => q.questionId).filter((item) => item);
};

export const getFilteredQuestionList = (tempId, prevQuestionsList) => {
  return prevQuestionsList.filter((item) => item.tempId !== tempId);
};

export const getEmptyQuestionObject = (faqId) => {
  return {
    questionId: undefined,
    // temporary id
    tempId: new Date().getTime(),
    order: 1,
    question: '',
    answer: '',
    faqId,
    isExpanded: true,
  };
};

export const getToggleStatusNotif = (status, locale) => {
  if (locale === 'en') {
    return status;
  }

  return `${status} شد`;
};
